import { API_AWARD, API_PROJECT, API_PROJECTS_SUMMARY, API_PROPOSAL, API_SUBAWARD } from "globals/constants";
import { spUrl } from "utils";
import { buildSearchParams, put, request } from "utils/proxy";


export const project = {
	/**
	 * @param {string} id
	 * @param {{}?} options
	 */
	get: (id, options) => request(spUrl(`${API_PROJECT}/${id}`), options),

	getList: (searchParams, options) => request(spUrl(`${API_PROJECT}${buildSearchParams(searchParams)}`), options),

	getSummary: (searchParams = { groupBy: "status" }, options) =>
		request(spUrl(`${API_PROJECTS_SUMMARY}${buildSearchParams(searchParams)}`), options),

	getAuthAccesses: (id, formType, options) => {
		const normalizedFormType = (formType ?? "proposal").toString().toLowerCase();
		const apiBase =
			normalizedFormType === "award"
				? API_AWARD
				: normalizedFormType === "subaward"
					? API_SUBAWARD
					: API_PROPOSAL;

		return request(spUrl(`${apiBase}/${id}/auth-accesses`), options);
	},

	/**
	 * @param {{formId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateAdminTeamMember: (params, body, options) =>
		put(spUrl(`${API_PROJECT}/${params.formId}/admin-team-members`), body, options),

	/**
	 * @param {{formId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateAccess: (params, body, options) => put(spUrl(`${API_PROJECT}/${params.formId}/accesses`), body, options),

	/**
	 * @param {{id}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	updateStatus: (params, body, options) => put(spUrl(`${API_PROJECT}/${params.id}/status`), body, options),

	/**
	 * @param {{id}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	updateTitle: (params, body, options) => put(spUrl(`${API_PROJECT}/${params.id}/title`), body, options),
};
